import VehicleCardPropertyRequisites from './VehicleCardPropertyRequisites.vue'
import VehiclePropertyCostHistory from './VehiclePropertyCostHistory.vue'
import VehicleCardSectionRemarks from './VehicleCardSectionRemarks.vue'
import CardSectionPropertiesWithImage from '../../components/Card/CardSectionPropertiesWithImage.vue'
import CardPropertyObjectCustom from '../../components/Card/CardPropertyObjectCustom.vue'

function getVehicleModelURLFn (object) {
  const vehicleBrandId = getVehicleBrandId(object)
  return '/service/delta/vehicle/brands' + '?includeModel=true' + (vehicleBrandId ? '&id=' + vehicleBrandId : '') + ''
}
function getVehicleBrandId (object) {
  const vehicleBrandId = object.vehicleBrand && object.vehicleBrand.length ? object.vehicleBrand[0].id : null
  return vehicleBrandId
}

function getVehicleSubTypeURLFn (object) {
  const vehicleTypeId = getVehicleTypeId(object)
  return '/service/delta/vehicle/types' + '?includeModel=true' + (vehicleTypeId ? '&id=' + vehicleTypeId : '') + ''
}
function getVehicleTypeId (object) {
  const vehicleTypeId = object.vehicleType && object.vehicleType.length ? object.vehicleType[0].id : null
  return vehicleTypeId
}

export function getCustomTabsList (config) {
  const { small, create, access, subtypeKey } = config
  if (create || subtypeKey === 'vehicleProvided') {
    return [
      {
        key: 'params',
        name: 'Основное',
        props: [
          { key: 'grz', name: 'ГРЗ' },
          { key: 'garage' },
          { key: 'vehicleBrand', componentProps: { select: false } },
          { key: 'vehicleModel', component: CardPropertyObjectCustom, componentProps: { select: true, getURL: getVehicleModelURLFn, cached: false, dialogLabel: 'Выбор моделей', responseKeyAvailableObjects: 'vehicleModels', getDependencyValue: getVehicleBrandId } },
          { key: 'vehicleType', name: 'Тип ТС', componentProps: { select: true } },
          { key: 'vehicleSubType', component: CardPropertyObjectCustom, componentProps: { select: true, getURL: getVehicleSubTypeURLFn, cached: false, dialogLabel: 'Выбор подтипов', responseKeyAvailableObjects: 'vehicleSubTypes', getDependencyValue: getVehicleTypeId } },
          { key: 'description' },
          { key: 'inUse', name: 'В эксплуатации' },
          { key: 'organization' },
          { key: 'costPerHour', name: 'Цена за час', type: 'table', component: VehiclePropertyCostHistory, _visible: access.editCosts },
          { key: 'costPerKilometer', name: 'Цена за километр', type: 'table', component: VehiclePropertyCostHistory, _visible: access.editCosts }
        ]
      }
    ]
  } else {
    return [
      {
        key: 'params',
        name: 'Основное',
        icon: 'mdi-car',
        component: CardSectionPropertiesWithImage,
        componentProps: {
          imageEditable: access.editImage,
          imageProperty: 'vehiclePhoto',
          expandCardOnImageClick: !!small,
          shiftedFieldsCount: small ? 2 : 5,
          width: small ? 86 : 230,
          height: small ? 86 : 230
        },
        props: [
          { key: 'grz', name: 'ГРЗ', componentProps: { copy: true } },
          { key: 'garage', componentProps: { copy: true } },
          { key: 'vehicleBrand', componentProps: { copy: true } },
          { key: 'vehicleModel', component: CardPropertyObjectCustom, componentProps: { getURL: getVehicleModelURLFn, cached: false, dialogLabel: 'Выбор моделей', responseKeyAvailableObjects: 'vehicleModels', getDependencyValue: getVehicleBrandId, copy: true } },
          { key: '$key', _editable: false, _show: o => !small, componentProps: { copy: true } },
          { key: 'vehicleType', name: 'Тип ТС', componentProps: { select: true } },
          { key: 'vehicleSubType', component: CardPropertyObjectCustom, componentProps: { select: true, getURL: getVehicleSubTypeURLFn, cached: false, dialogLabel: 'Выбор подтипов', responseKeyAvailableObjects: 'vehicleSubTypes', getDependencyValue: getVehicleTypeId } },
          { key: 'description' },
          { key: 'crewSize', name: 'Численность экипажа' },
          { key: 'inUse', name: 'В эксплуатации', _editable: access.editPublic },
          { key: '_fuel', type: 'separator', name: 'Топливо' },
          { key: 'lastFuelValue', name: 'Текущие показания уровня топлива', type: 'double' },
          { key: 'fuelTypes', name: 'Типы топлива', _select: true, listvalues: [], ismultiselect: true, objectchoosetypes: [{ key: 'fuelType' }], objectchoosesubtypes: false },
          { key: 'fuelTankVolume', name: 'Объем бака' },
          { key: 'normalFuelConsumption', name: 'Норматив расхода топлива', componentProps: { rowsPerPage: 0, hideBottom: true } },
          { key: '_service', type: 'separator', name: 'Техническое обслуживание' },
          { key: 'lastOdometerValue', name: 'Текущие показания одометра', type: 'double' },
          { key: 'nextServiceMileage', name: 'Пробег для проведения ТО', type: 'integer' },
          { key: 'serviceRequired' },
          { key: 'lastServiceMileage' },
          { key: 'serviceMileageFrequency' },
          { key: '_serviceEnd', type: 'separator' },
          { key: 'washAllowed' },
          { key: 'requestAllowed' },
          { key: 'workArea' },
          { key: 'workTimeLimit' },
          { key: 'qualificationType' },
          { key: 'dontGiveUntilFix' },
          { key: 'reason' },
          { key: 'state' },
          { key: 'currentBrigade', name: 'Текущая бригада', type: 'object', componentProps: { copy: true } },
          { key: 'vehicleEmployee', name: 'Водитель', _icon: 'mdi-account-box-outline', componentProps: { copy: true } }
        ]
      },
      {
        key: 'ownerView',
        name: 'Принадлежность транспортного средства',
        icon: 'mdi-clipboard-alert',
        props: [
          // { key: 'contract' }, // Является ТС Подрядчика
          { key: 'organization', componentProps: { copy: true } },
          { key: 'organizationRequisites', type: 'custom', name: 'Реквизиты организации', component: VehicleCardPropertyRequisites },
          { key: 'costPerHour', name: 'Цена за час', type: 'table', component: VehiclePropertyCostHistory, _visible: access.editCosts },
          { key: 'costPerKilometer', name: 'Цена за километр', type: 'table', component: VehiclePropertyCostHistory, _visible: access.editCosts }
        ]
      },
      {
        key: 'equipment',
        name: 'Оборудование',
        icon: 'mdi-cogs',
        props: [
          { key: 'geotracker', name: 'Трекер', componentProps: { copy: true } },
          { key: 'vehicleStock', componentProps: { copy: true } },
          { key: 'videocam', componentProps: { copy: true } }
        ]
      },
      {
        key: 'remarks',
        name: 'Замечания',
        icon: 'mdi-alert',
        component: VehicleCardSectionRemarks
      },
      {
        key: 'files',
        name: 'Документы',
        icon: 'mdi-file-multiple'
      }
    ]
  }
}
